module.exports = function(app) {
    app.directive('requestAppointmentForm', function() {
        return {
            restrict: 'A',
            replace: true,
            template:  require('directives/requestAppointmentForm.html'),

            scope: {
                appointment: '=requestAppointmentForm', // Appointment object
                conditions: '=',                        // List of conditions for condition type select.
                onSubmit: '&',                          // Submit function called when the form is submitted.
                onBack: '&',                            // Back function called when the back button is clicked.
                errorMessage: '=?',
                formClass: '=?',
                mdrButton: '=?',
                transmitting: '=?'
            },

            controller: ['$scope', 'ahnAppointment', function($scope, ahnAppointment) {

                $scope.mdrButton = $scope.mdrButton || false;
                $scope.transmitting = false;
                $scope.useDate = (window && window.Modernizr && window.Modernizr.inputtypes && window.Modernizr.inputtypes.date);

                // Hide the condition select for now... only allow free form entry using the condition other field.
                $scope.displayConditionSelect = false;

                $scope.submit = function() {
                    if ($scope.appointmentForm.$valid) {
                        $scope.transmitting = true;

                        var params = {
                            'd_n': $scope.appointment.preferred_dr
                        };

                        $scope.onSubmit( { promise: ahnAppointment.scheduleRequest($scope.appointment, params) } );
                    }
                };

            }]
        };
    });
};
